import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UserWithResolvedScopes } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createDriverApi, driverKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useDeactivateDriver(): UseMutationResult<UserWithResolvedScopes, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createDriverApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<UserWithResolvedScopes, Error, string>({
    mutationFn: (id: string) => api.deactivateDriver(id),
    ...createMutationCallbacks({
      errorKey: 'drivers.toast.deactivateError',
      invalidateKeys: [driverKeys.lists()],
      queryClient,
      successKey: 'drivers.toast.deactivated',
      t,
    }),
  });
}

export function useActivateDriver(): UseMutationResult<UserWithResolvedScopes, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createDriverApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<UserWithResolvedScopes, Error, string>({
    mutationFn: (id: string) => api.activateDriver(id),
    ...createMutationCallbacks({
      errorKey: 'drivers.toast.activateError',
      invalidateKeys: [driverKeys.lists()],
      queryClient,
      successKey: 'drivers.toast.activated',
      t,
    }),
  });
}
